import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Alert, Box, Button, Paper, TextField } from '@mui/material';
import { AI_COMING_SOON_FEATURES, AI_COMING_SOON_OPEN_EVENT, AI_COMING_SOON_TEXT, selectAiComingSoon } from './comingSoonConfig';

export default function AiComingSoon() {
  const comingSoon = useSelector(selectAiComingSoon);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (!comingSoon) {
      setIsOpen(false);
      return undefined;
    }
    const open = () => setIsOpen(true);
    window.addEventListener(AI_COMING_SOON_OPEN_EVENT, open);
    return () => window.removeEventListener(AI_COMING_SOON_OPEN_EVENT, open);
  }, [comingSoon]);

  if (!comingSoon) return null;

  return (
    <>
      <Button
        variant="contained"
        aria-label={isOpen ? 'Close AI Assistant chat' : 'Open AI Assistant chat'}
        onClick={() => setIsOpen((v) => !v)}
        data-testid="ai-chat-toggle"
        sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 1300 }}
      >
        {isOpen ? 'Close' : 'AI Assistant'}
      </Button>

      {isOpen && (
        <Paper
          elevation={8}
          data-testid="ai-chat-panel"
          sx={{ position: 'fixed', bottom: 80, right: 24, width: 360, maxWidth: 'calc(100vw - 32px)', zIndex: 1300, p: 1.5 }}
        >
          <Alert severity="info" data-testid="ai-coming-soon">{AI_COMING_SOON_TEXT}</Alert>
          <Box component="ul" data-testid="ai-coming-soon-features" sx={{ pl: 2.5, my: 1, typography: 'caption', color: 'text.secondary' }}>
            {AI_COMING_SOON_FEATURES.map((f) => <li key={f}>{f}</li>)}
          </Box>
          <Box sx={{ display: 'flex', gap: 1 }}>
            <TextField size="small" fullWidth disabled placeholder="Coming soon" inputProps={{ 'aria-label': 'Message AI Assistant' }} />
            <Button variant="contained" disabled>Send</Button>
          </Box>
        </Paper>
      )}
    </>
  );
}
